/**
 * What a video upload needs before it counts as uploaded (ADR 0014).
 *
 * Shared by `publishVideoAsset`, which refuses a draft missing any of these, and the admin's bulk
 * uploader, which uses it to say what is left before the operator presses Finish — one rule, so the
 * button cannot offer a save the server will refuse.
 */
export interface VideoDetails {
    title: string;
    description: string;
    presenterId: string | null;
    tagIds: readonly string[];
}

export type VideoDetailField = "title" | "description" | "presenter" | "tags";

/** The required details still missing, in form order. Empty means ready to publish. */
export const missingVideoDetails = (details: VideoDetails): VideoDetailField[] => {
    const missing: VideoDetailField[] = [];
    if (!details.title.trim()) missing.push("title");
    if (!details.description.trim()) missing.push("description");
    if (!details.presenterId) missing.push("presenter");
    if (details.tagIds.length === 0) missing.push("tags");
    return missing;
};

/**
 * The most ids `videoAssetsByIds` answers in one call. The bulk uploader polls its queue in chunks of
 * this size, so the two cannot disagree.
 */
export const VIDEO_ASSETS_BY_IDS_MAX = 100;

/** The most videos one "build a course from uploads" request takes. */
export const COURSE_FROM_VIDEOS_MAX = 100;
